<template>
  <div class="app-container">
    <PageHeader title="商品管理"  icon="el-icon-goods" />
    <!-- 搜索区域 -->
    <div class="search-box">
      <el-card shadow="never">
        <el-form :inline="true" :model="queryParams" class="search-form" size="small">
          <el-form-item label="商品名称">
            <el-input v-model="queryParams.name" placeholder="请输入商品名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="商品类型">
            <el-select v-model="queryParams.goodsType" placeholder="请选择类型" clearable>
              <el-option v-for="item in categoryOptions" 
                :key="item.value" 
                :label="item.label" 
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品状态">
            <el-select v-model="queryParams.status" placeholder="请选择状态" clearable>
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="上架" :value="1"></el-option>
              <el-option label="下架" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="search-btn-group" >
            <el-button type="primary" icon="el-icon-search" @click="handleQuery" align="left">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-toolbar">
      <el-button-group>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增商品</el-button>
        <!-- <el-button type="success" icon="el-icon-download" size="small">导出</el-button> -->
      </el-button-group>
    </div>

    <!-- 数据表格 -->
    <div class="table-box">
      <el-table
        :data="productList"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{
          background:'#f5f7fa',
          color:'#606266',
          fontWeight: '600',
          padding: '12px 0',
          height: '50px'
        }"
        :cell-style="{
          padding: '8px 0',
          height: '50px'
        }"
        height="calc(100vh - 280px)">
        <el-table-column type="index" label="序号" width="60" align="center"/>
        <!-- <el-table-column prop="code" label="商品编码" width="120" align="center" show-overflow-tooltip/> -->
        <el-table-column prop="name" label="商品名称" min-width="200" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="product-info">
              <span class="product-name">{{ scope.row.name }}</span>
              <el-tooltip effect="dark" :content="scope.row.description" placement="top">
                <i class="el-icon-info info-icon"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsType" label="商品类型" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.goodsType }}
          </template>
        </el-table-column>
        <el-table-column prop="goodsNodeId" label="商品型号" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.goodsNodeId || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="goodsSpec" label="规格" width="180" align="center" show-overflow-tooltip/>
        <el-table-column prop="price" label="价格" width="120" align="center">
          <template slot-scope="scope">
            <span class="price">¥ {{ scope.row.price.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deposit" label="押金" width="120" align="center"></el-table-column>
        <el-table-column prop="inventory" label="库存" width="100" align="center">
          <template slot-scope="scope">
            <span :class="['inventory', scope.row.inventory < 50 ? 'stock-warning' : '']">
              {{ scope.row.inventory }} 
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small" effect="plain">
              {{ scope.row.status === 1 ? '上架' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="160" align="center">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="saleType" label="销售模式" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="getSaleTypeTagType(scope.row.saleType)">
              {{ getSaleTypeText(scope.row.saleType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button-group class="operation-group">
              <el-button 
                size="mini" 
                type="primary" 
                icon="el-icon-edit" 
                @click="handleEdit(scope.row)">
                编辑
              </el-button>
              <el-button 
                size="mini" 
                :type="scope.row.status === 1 ? 'warning' : 'success'"
                @click="handleStatusChange(scope.row)">
                {{ scope.row.status === 1 ? '下架' : '上架' }}
              </el-button>
              <el-button 
                size="mini" 
                type="danger" 
                icon="el-icon-delete" 
                @click="handleDelete(scope.row)">
                删除
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog 
      :title="dialog.title" 
      :visible.sync="dialog.visible" 
      width="700px" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      custom-class="custom-dialog">
      <template v-slot:default>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="商品名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入商品名称"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品类型" prop="goodsType">
                <el-cascader
                  v-model="form.goodsType"
                  :options="categoryTree"
                  :props="categoryProps"
                  placeholder="请选择商品类型"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <!-- <el-col :span="12">
              <el-form-item label="商品编码" prop="code">
                <el-input v-model="form.code" placeholder="请输入商品编码"/>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="商品型号" prop="goodsNodeId">
                <el-input v-model="form.goodsNodeId" placeholder="请输入商品型号"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品价格" prop="price">
                <el-input-number 
                  v-model="form.price" 
                  :precision="2" 
                  :step="0.01" 
                  :min="0"
                  controls-position="right"
                  style="width: 100%"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
          
            <el-col :span="12">
              <el-form-item label="商品押金" prop="deposit">
                <el-input-number 
                  v-model="form.deposit" 
                  :precision="2" 
                  :step="0.01" 
                  :min="0"
                  controls-position="right"
                  style="width: 100%"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品规格" prop="goodsSpec">
                <el-input v-model="form.goodsSpec" placeholder="请输入商品规格"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
          
            <el-col :span="12">
              <el-form-item label="销售模式" prop="saleType">
                <el-select v-model="form.saleType" placeholder="请选择销售模式" style="width: 100%">
                <!-- <el-option  label="全部" :value="0"/> -->
                  <el-option label="仅押金" :value="1" />
                  <el-option label="仅售卖" :value="2" />
                  <el-option label="两者兼可" :value="3" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="0">下架</el-radio>
            </el-radio-group>
          </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="商品描述">
            <el-input type="textarea" v-model="form.description" :rows="3" placeholder="请输入商品描述"/>
          </el-form-item>

         
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right;margin-top: 20px;">
        <el-button @click="dialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
      </template>
  
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader.vue'
import request from '@/utils/request'

export default {
  name: 'ProductManage',
  components: { PageHeader },
  data() {
    return {
      // 查询参数
      queryParams: {
        page: 1,
        size: 10,
        name: '', // 商品名称
        status: -1, // 状态，-1表示全部
        goodsType: undefined,
        goodsSpec: '',//商品规格
        inventory: undefined//库存
      },
      // 总条数
      total: 0,
      // 加载状态
      loading: false,
      // 商品列表数据
      productList: [],
      // 类目选项
      categoryOptions: [],
      // 对话框
      dialog: {
        visible: false,
        title: ''
      },
      // 表单数据
      form: {
        id: undefined,
        name: '',
        goodsType: undefined,//
        goodsSpec: '',//
        goodsNodeId: '', // 商品型号
        price: 0,
        deposit: 0, // 商品押金
        saleType: 2, // 默认仅售卖
        status: 1,
        imageUrl: '',
        description: ''
      },
      // 表单校验规则
      rules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        goodsType: [
          { required: true, message: '请选择商品类型', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ],
        deposit: [
          { required: true, message: '请输入商品押金', trigger: 'blur' }
        ],
        goodsNodeId: [
          { required: true, message: '请输入商品型号', trigger: 'blur' }
        ],
        saleType: [
          { required: true, message: '请选择销售模式', trigger: 'change' }
        ]
      },
      categoryTree: [], // 类目树形数据
      categoryProps: {
        value: 'category_id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: false // 只返回最后一级的 ID
      }
    }
  },
  created() {
    this.getList()
    this.getCategoryOptions()
  },
  methods: {
    // 获取商品列表
    async getList() {
      try {
        this.loading = true
        const res = await request({
          url: '/api/v1/goods/list',
          method: 'POST',
          data: {
            page: this.queryParams.page,
            size: this.queryParams.size,
            name: this.queryParams.name || '',
            status: this.queryParams.status
          }
        })

        if (res.status === 1 && res.data) {
          // 处理返回的数据
          this.productList = res.data.map(item => ({
            id: item.GoodID,//商品id
            goodsType: item.FirstKind,//商品类型
            categoryName: (item.CategoryID),//商品类型名称
            goodsSpec: item.GoodSpecs,//商品规格
            goodsNodeId: item.GoodModel,//商品型号
            secondKind: item.SecondKind,//二级分类
            thirdKind: item.ThirdKind,//三级分类
            name: item.Name,//商品名称
            price: item.Price,//商品价格
            saleType: item.SaleType,//销售模式
            adjustMoney: item.AdjustMoney,//调整金额
            inventory: item.Inventory,//库存
            status: item.Status,//状态
            imageUrl: item.ImageUrl,//商品图片
            createBy: item.CreateBy,//创建人
            createdAt: item.CreatedAt,//创建时间
            updateBy: item.UpdateBy,//更新人
            updatedAt: item.UpdatedAt,//更新时间
            soft: item.Soft,//软件
            deposit: item.Deposit//押金
          }))
          this.total = res.total || 0
        } else {
          this.productList = []
          this.total = 0
          this.$message.error(res.msg || '获取商品列表失败')
        }
      } catch (error) {
        console.error('获取商品列表错误:', error)
        this.$message.error('获取商品列表失败')
        this.productList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    // 获取类目选项
    async getCategoryOptions() {
      try {
        const res = await request({
          url: '/api/v1/category/list',
          method: 'POST',
          data: {
            page: 1,
            size: 1000 // 获取所有类目
          }
        })

        if (res.status === 1 && res.data) {
          // 将平级数据转换为树形结构
          this.categoryTree = this.convertToTree(res.data)
        } else {
          this.$message.error('获取商品类目失败')
        }
      } catch (error) {
        console.error('获取商品类目错误:', error)
        this.$message.error('获取商品类目失败')
      }
    },
    // 添加转换树形结构的方法
    convertToTree(data) {
      // 创建一个映射表
      const map = {}
      data.forEach(item => {
        map[item.category_id] = {
          category_id: item.category_id,
          name: item.category_name,
          parent_id: item.parent_id,
          children: []
        }
      })

      // 构建树形结构
      const tree = []
      data.forEach(item => {
        const node = map[item.category_id]
        if (item.parent_id === '0' || !item.parent_id) {
          // 根节点
          tree.push(node)
        } else {
          // 子节点
          const parent = map[item.parent_id]
          if (parent) {
            parent.children.push(node)
          }
        }
      })

      return tree
    },
    // 查询按钮
    async handleQuery() {
      this.queryParams.page = 1
      await this.getList()
    },
    // 重置按钮
    resetQuery() {
      this.queryParams = {
        page: 1,
        size: 10,
        name: '',
        status: -1, // 重置时也设为-1
        goodsType: undefined,
        goodsSpec: '',
        inventory: undefined
      }
      this.getList()
    },
    // 新增按钮
    handleAdd() {
      this.dialog.title = '新增商品'
      this.dialog.visible = true
      this.form = {
        name: '',
        categoryId: undefined,
        price: 0,
        stock: 0,
        status: 1
      }
    },
    // 编辑按钮
    handleEdit(row) {
      this.dialog.title = '编辑商品'
      this.dialog.visible = true
      this.form = { ...row }
      console.log(this.form)
    },
    // 删除按钮
    handleDelete(row) {
      this.$confirm('确认删除该商品吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const res = await request({
            url: '/api/v1/goods/delete',
            method: 'POST',
            data: {
              good_id: row.id
            }
          })

          if (res.status === 1) {
            this.$message.success('删除成功')
            if (this.productList.length === 1 && this.queryParams.page > 1) {
              this.queryParams.page--
            }
            this.getList()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除商品错误:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {
        // 取消删除操作
      })
    },
    // 提交表单
    async submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            // 构造请求参数
            const params = {
              good_id: this.form.id || '', // 编辑时传ID，新增时为空
              name: this.form.name,//商品名称
              price: this.form.price,//商品价格
              status: this.form.status,//商品状态
              category_id: this.form.goodsType, // 确保这里传递的是选中的类目ID
              image_url: this.form.imageUrl || '',//商品图片
              deposit: 0,//商品押金
              good_model: this.form.goodsNodeId || '',//商品型号
              good_type: 1,//商品类型
              good_specs: this.form.goodsSpec || '',//商品规格
              sale_type: this.form.saleType, // 使用选择的销售模式
              adjust_money: 1,//调整金额
              Deposit: this.form.deposit || 0//押金
            }

            const res = await request({
              url: '/api/v1/goods/save',
              method: 'POST',
              data: params
            })

            if (res.status === 1) {
              this.$message.success('保存成功')
              this.dialog.visible = false
              this.getList() // 刷新列表
            } else {
              this.$message.error(res.msg || '保存失败')
            }
          } catch (error) {
            console.error('保存商品错误:', error)
            this.$message.error('保存失败')
          }
        }
      })
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.queryParams.size = val
      this.getList()
    },
    // 页码改变
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getList()
    },
    // 状态切换
    handleStatusChange(row) {
      const status = row.status === 1 ? 0 : 1
      const statusText = status === 1 ? '上架' : '下架'
      this.$confirm(`确认${statusText}该商品吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        // 调用状态修改接口
        this.$message.success(`${statusText}成功`)
        row.status = status
      })
    },
    // 格式化时间
    formatDateTime(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    // // 根据类目ID获取类目名称
    // getCategoryName(categoryId) {
    //   if (!categoryId) return '-'
    //   // 递归查找类目名称
    //   const findName = (tree) => {
    //     for (const node of tree) {
    //       if (node.category_id === categoryId) {
    //         return node.name
    //       }
    //       if (node.children && node.children.length) {
    //         const name = findName(node.children)
    //         if (name) return name
    //       }
    //     }
    //     return null
    //   }
    //   return findName(this.categoryTree) || '-'
    // },
    // 获取销售模式文本
    getSaleTypeText(type) {
      const typeMap = {
        1: '仅押金',
        2: '仅售卖',
        3: '两者兼可'
      }
      return typeMap[type] || '-'
    },
    // 获取销售模式标签类型
    getSaleTypeTagType(type) {
      const typeMap = {
        1: 'warning', // 仅押金
        2: 'success', // 仅售卖
        3: 'primary'  // 两者兼可
      }
      return typeMap[type] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/common.css';

.price {
  color: #f56c6c;
  font-weight: 500;
}

.custom-dialog {
  .el-form-item {
    margin-bottom: 20px;
  }
}

.el-button-group {
  .el-button {
    margin-right: 0;
  }
}

.operation-group {
  display: inline-flex;
  
  .el-button {
    padding: 5px 8px;
    margin: 0 !important;
    
    &:not(:last-child) {
      border-right: 1px solid #dcdfe6;
    }
    
    &:hover {
      position: relative;
      z-index: 1;
    }
    
    // 调整图标和文字的间距
    [class^="el-icon-"] {
      margin-right: 3px;
    }
  }
}

// 调整表格内容的垂直对齐
:deep(.el-table__cell) {
  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    
    &.is-right {
      justify-content: flex-end;
      padding-right: 16px;
    }
    
    &.is-left {
      justify-content: flex-start;
      padding-left: 16px;
    }
  }
}

// 优化表格内容样式
.product-info {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .product-name {
    flex: 1;
    text-align: left;
  }
  
  .info-icon {
    color: #909399;
    cursor: pointer;
    
    &:hover {
      color: #409EFF;
    }
  }
}

// 优化状态标签样式
:deep(.el-tag) {
  padding: 0 10px;
  height: 24px;
  line-height: 22px;
}

// 优化数字显示样式
.price, .stock {
  font-family: Arial, sans-serif;
  
  &.stock-warning {
    color: #e6a23c;
  }
}


.dealer-manage {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    padding: 0;
  }

  .filter-container {
    padding-bottom: 10px;
  }

  .operation-container {
    margin-bottom: 20px;
  }

  .pagination-container {
    padding: 20px 0;
    text-align: right;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .upload-demo {
    margin-bottom: 20px;
  }

  .el-upload__tip {
    line-height: 1.2;
    margin-top: 5px;
    color: #909399;
  }
}
</style> 